import { z } from 'zod';

export const uuidSchema = z.uuid();
export const idParamSchema = z.object({ id: uuidSchema });
export const slugParamSchema = z.object({ slug: z.string().min(1).max(120) });

export const slugSchema = z
  .string()
  .min(2)
  .max(80)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'invalid_slug');

export const countryCodeSchema = z.string().regex(/^[A-Z]{2}$/, 'invalid_country_code');

export const isoDateTimeSchema = z.iso.datetime({ offset: true });

// Pagination contract (CLAUDE.md conventions): default 25, max 100.
export const paginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(25),
});
export type PaginationQuery = z.infer<typeof paginationQuerySchema>;

export interface PageMeta {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

// Response envelope (CLAUDE.md conventions)
export interface ApiSuccess<T> {
  data: T;
  meta?: PageMeta;
}
export interface ApiErrorBody {
  error: { code: string; message: string; correlationId: string; details?: unknown };
}

export const emailSchema = z.email().max(254);
export const passwordSchema = z.string().min(12, 'password_too_short').max(128);
export const phoneSchema = z.string().min(7).max(20).regex(/^[+()0-9 -]+$/, 'invalid_phone');
export const urlSchema = z.url().max(2048);
export const nameSchema = z.string().trim().min(1).max(100);
